<script lang="ts" setup>
interface Props {
  text?: string
  retry?: boolean
  icon?: string
  severity?: string
  disabled?: boolean
  onRetry?: (evt: Event) => void
}

withDefaults(defineProps<Props>(), {
  text: 'Reintentar buscar lista',
  icon: 'icon-[ph--arrow-u-down-left-bold]',
  severity: 'warning',
  disabled: false,
  onRetry: undefined,
})
</script>

<template>
  <PvInputGroup v-if="retry && !disabled">
    <PvInputGroupAddon class="flex-grow">
      {{ text }}
    </PvInputGroupAddon>

    <PvButton
      :icon
      :severity
      @click="onRetry"
    />
  </PvInputGroup>
  <slot v-else />
</template>
